


















import { defineComponent } from '@vue/composition-api';
import { GoalSummaryDto, GoalStatus } from '@/generated/api.clients';
import { LearnerGoalsStoreKey, UserStoreKey } from '@/store/StoreInjectionKeys';
import { injectStrict } from '@/lib/utils';
import router from "@/router";

export default defineComponent({
  name: 'GoalCardItem',
  props: {
      goal: GoalSummaryDto
  },
  setup(props) {
    const learnerGoalsStore = injectStrict(LearnerGoalsStoreKey);
    const userStore = injectStrict(UserStoreKey);

    learnerGoalsStore.actions.getGoals();

    function setCurrentGoal(id: number): void {
      learnerGoalsStore.actions.setCurrentGoal(id);
      router.push(`/learner/Goals/${userStore.state.ContextUserId}`)
    }
    return {
      setCurrentGoal,
      GoalStatus
    }
  }
})
